module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/ma-gallery/ma-gallery-06-6288a1f37777d508976c34a6aa8536cc.jpg";